import React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { AppLayout } from '@/common/AppLayout';
import { FindCare } from './FindCare';
import { PriceCare } from './PriceCare';
import { InternalServerError } from './InternalServerError';
import { PageNotFound } from './PageNotFound';
import { useGetThemePortalProps } from '@/hooks/useGetThemePortalProps';
import { PortalName } from '@/common/DataModel/PortalData';

// UMR-leased members (per checkUmrLeasedEligibility) have no Find a Provider access.
const FindCareRoute = () => {
  const { portalName } = useGetThemePortalProps();
  const { navigate } = useRouter();
  const isUmrLeased = portalName === PortalName.UMR_LEASED;

  React.useEffect(() => {
    if (isUmrLeased) {
      navigate('/costestimate', { replace: true });
    }
  }, [isUmrLeased, navigate]);

  return isUmrLeased ? null : <FindCare />;
};

export const Routes = () => {
  return (
    <Router.Routes title="{{title}}">
      <Router.Route path="/" element={<AppLayout />}>
        <Router.Route path="findcare/*" element={<FindCareRoute />} />
        <Router.Route path="costestimate/*" element={<PriceCare />} />
        <Router.Route path="error" element={<InternalServerError />} />
        <Router.Route path="*" element={<PageNotFound />} />
      </Router.Route>
    </Router.Routes>
  );
};
